var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.283 4.999H10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h1.135a3.264 3.264 0 0 1 1.228-4.4l.12-.07a3.125 3.125 0 0 1 4.27 1.143l.437.758a.5.5 0 0 1-.866.5l-.438-.758a2.125 2.125 0 0 0-2.903-.777l-.12.07a2.264 2.264 0 0 0-.84 3.072zM2 5.999h8a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
});
const SvgUnlocksmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnlocksmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjI4MzA5IDQuOTk5MDJIMTBDMTEuMTA0NiA0Ljk5OTAyIDEyIDUuODk0NDUgMTIgNi45OTkwMlY5Ljk5OTAyQzEyIDExLjEwMzYgMTEuMTA0NiAxMS45OTkgMTAgMTEuOTk5SDJDMC44OTU0MzEgMTEuOTk5IDAgMTEuMTAzNiAwIDkuOTk5MDJWNi45OTkwMkMwIDUuODk0NDUgMC44OTU0MzEgNC45OTkwMiAyIDQuOTk5MDJIMy4xMzUzMkMyLjI3OTIzIDMuNDQ0NTkgMi44MjI0MiAxLjQ4NzQ0IDQuMzYyNzYgMC41OTgxMjRMNC40ODMyMyAwLjUyODU2N0M1Ljk3NzkgLTAuMzM0Mzc4IDcuODg5MTIgMC4xNzc3MzIgOC43NTIwNiAxLjY3MjRMOS4xODk1NiAyLjQzMDE3QzkuMzI3NjMgMi42NjkzMiA5LjI0NTY5IDIuOTc1MTEgOS4wMDY1NSAzLjExMzE4QzguNzY3NCAzLjI1MTI1IDguNDYxNjEgMy4xNjkzMiA4LjMyMzUzIDIuOTMwMTdMNy44ODYwMyAyLjE3MjRDNy4yOTkyMyAxLjE1NjAzIDUuOTk5NiAwLjgwNzc5IDQuOTgzMjMgMS4zOTQ1OUw0Ljg2Mjc2IDEuNDY0MTVDMy43ODc3IDIuMDg0ODMgMy40MTI5IDMuNDU1NDMgNC4wMjI1MiA0LjUzNjhMNC4yODMwOSA0Ljk5OTAyWk0yIDUuOTk5MDJIMTBDMTAuNTUyMyA1Ljk5OTAyIDExIDYuNDQ2NzQgMTEgNi45OTkwMlY5Ljk5OTAyQzExIDEwLjU1MTMgMTAuNTUyMyAxMC45OTkgMTAgMTAuOTk5SDJDMS40NDc3MiAxMC45OTkgMSAxMC41NTEzIDEgOS45OTkwMlY2Ljk5OTAyQzEgNi40NDY3NCAxLjQ0NzcyIDUuOTk5MDIgMiA1Ljk5OTAyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";